<template>
  <div>
    <Popover ref="operationalCodeEditPopover" :showHeader="true" headerTitle="Operational Code" sizeClass="popover-xlarge">
      <div class="p-2">
        <div class="row">
          <div class="col-6" v-if="order">
            <PopoverPropertyRow label="Order">
              <LinkOrder :id="order.id" :name="order.sequenceNumber" />
            </PopoverPropertyRow>
            <PopoverPropertyRow label="Contact" v-if="order.contact">
              <LinkContact :id="order.contact.id" :name="order.contact.name" />
            </PopoverPropertyRow>
            <PopoverPropertyRow label="Order Estimated">
              {{formatDateTime(order.dateEstimated)}}
            </PopoverPropertyRow>
            <PopoverPropertyRow label="Customer Requested">
              {{orderRequestedDateInfo(order)}}
            </PopoverPropertyRow>
            <PopoverPropertyRow label="Production End / Despatch Ready">
              {{formatDateTime(order.dateDespatchStarted) || '-'}}
            </PopoverPropertyRow>
            <PopoverPropertyRow label="Task Scheduled">
              {{formatDateTime(taskScheduleStartDate) || '-'}}
            </PopoverPropertyRow>
          </div>
          <div class="col-6">
            <PopoverPropertyRow label="Operational Code">
              <LabelBadge :class="`task-operational-category-${taskOpCodeCategoryLookup(codeValue)}`">{{formatLookupName(codeValue, ItemOperationalReportingCodeLookup)}}</LabelBadge><br />
              <FormButton class="btn-default btn-xs mt-2" @click.prevent="displayOperationalCodeSelect">Select Code</FormButton>
              <FormButton class="btn-default btn-xs mt-2" @click.prevent="resetOperationalCode">Reset Code</FormButton>
            </PopoverPropertyRow>
            <PopoverPropertyRow label="Operational Note">
              <FormInputText :value="codeNote" @input="$emit('update:codeNote', $event)" placeholder="Additional Notes" />
            </PopoverPropertyRow>
          </div>
        </div>
      </div>
    </Popover>

    <Popover ref="opCodeSelectPopover" :showHeader="true" headerTitle="Operational Code" sizeClass="popover-large" :scrollable="true">
      <div class="p-2">
        <button v-for="code in availableOperationalCodes" :key="code.value" type="button" :class="['btn-reporting-code', `task-operational-category-${code.category}`]" @click.stop.prevent="$emit('update:codeValue', code.value); $refs.opCodeSelectPopover.hidePopover()">
          <div class="selection">
            <i class="far fa-check-circle" v-if="codeValue == code.value" />
          </div>
          <div class="content">
            {{code.name}}<br />
            <span class="description">{{code.description}}</span>
          </div>
        </button>
      </div>

    </Popover>
  </div>
</template>


<style lang="scss" scoped>
.btn-reporting-code {
  width: 100%;
  min-height: 48px;
  padding: 6px;
  text-align: left;
  color: #ffffff;
  border-radius: 10px;
  font-weight: 600;
  border: none;
  background-color: #E8F5E9;
  color: #288A51;
  cursor: pointer;
  margin-bottom: 0.5rem;
  line-height: 1rem;
  display: flex;
  flex-direction: row;
}
.btn-reporting-code .selection {
  width: 30px;
  font-size: 20px;
  line-height: 42px;
  vertical-align: middle;
}
.btn-reporting-code .content {
  flex: 1;
}

.btn-reporting-code:hover {
  box-shadow: 0px 3px 0px 0px rgba(0, 0, 0, 0.2);
}
.btn-reporting-code:active {
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.2);
  transform: translateY(1px);
}
.btn-reporting-code .description {
  font-size: 11px;
  font-weight: normal;
  line-height: 11px;
}

</style>


<script>
import TaskDespatchMixin from '@/modules/tasks/mixins/taskDespatchMixin'
import Popover from '@/components/popover.vue'
import PopoverPropertyRow from '@/components/popoverPropertyRow'

import { ItemOperationalReportingCodes, ItemOperationalReportingCodeLookup } from '@/store/types'

export default {
  name: 'TaskOperationalCodePopover',
  mixins: [
    TaskDespatchMixin
  ],
  components: {
    Popover,
    PopoverPropertyRow
  },
  props: {
    order: Object,
    taskScheduleStartDate: String,

    codeValue: String,
    codeNote: String
  },
  data() {
    return {
      
    }
  },
  computed: {
    availableOperationalCodes() {
      if(!this.taskScheduleStartDate || !this.order)
        return []

      // Calculate available options based on task & order info
      var availableCodes = this.calculateAvailableReportingCodeList({ scheduleStartDate: this.taskScheduleStartDate }, this.order)

      return availableCodes.map(code => {
        return ItemOperationalReportingCodeLookup.find(info => info.value == code)
      })
    }
  },
  created() {
    this.ItemOperationalReportingCodeLookup = ItemOperationalReportingCodeLookup
  },
  methods: {
    displayFromElement(el) {
      this.$refs.operationalCodeEditPopover.displayFromElement(el)
    },
    displayOperationalCodeSelect(evt) {
      this.$refs.opCodeSelectPopover.displayFromElement(evt.target)
    },
    orderRequestedDateInfo(order) {
      if(!order.dateRequested)
        return 'N/A'

      if(moment(order.dateRequested).local().isBefore(moment(order.dateEstimated).local(), 'day'))
        return `Requested Earlier - ${this.formatDate(order.dateRequested)}`

      return `Requested Later - ${this.formatDate(order.dateRequested)}`
    },
    taskOpCodeCategoryLookup(code) {
      var lookupInfo = ItemOperationalReportingCodeLookup.find(c => c.value == code)
      if(!lookupInfo)
        return 'none'
      return lookupInfo.category
    },
    resetOperationalCode() {
      this.$emit('resetCode')
    }
  }
}
</script>